export const PURCHASE_BAR_ANCHOR_TOP_CLASS = '.js-purchase-bar-anchor-top';
export const PURCHASE_BAR_ANCHOR_BOTTOM_CLASS = '.js-purchase-bar-anchor-bottom';
export const PURCHASE_BAR_ANCHOR_TARGET_CLASS = '.js-purchase-bar-anchor-target';
export const PURCHASE_BAR_ANCHOR_TARGET_MOBILE_ONLY_CLASS = '.js-purchase-bar-anchor-target-mobile';
export const PURCHASE_BAR_CLASS = 'js-purchase-bar';
